import React from 'react';
import { Header } from '../Layouts/Header';
import '../../styles/homepage.css';
import '../../styles/otherpage.css';
import download from '../../assets/imgs/download.svg';
import Footer from '../Layouts/Footer';
import CallToActionButton from '../Layouts/CallToActionButton';

export const DownloadPage = () => {
  return (
    <div className='home-container'>
      <header className='header-container'>
        <Header action='/download' />
        <div className='hero-container'>
          <div className='intro'>
            <h1>
              <span>
                Download the <span style={{ color: '#b49714' }}>#1</span> Luxury
                Cab app
              </span>
            </h1>
            <h3>We are on all platforms</h3>
            <div className='store-buttons'>
              <div>
                <CallToActionButton store={true} />
              </div>
            </div>
          </div>
          <div className='svg-content'>
            <img src={download} width={550} height={438} alt='app screenshot' />
          </div>
        </div>
      </header>
      <main className='home-main privacy'>
        <h2>Download LionTaxi on Google Play Store</h2>
        <p>
          If you're using an Android device (e.g Samsung, Itel, Tecno, Infinix,
          Gionee, HTC, Nokia, etc), you{' '}
          <a href='https://play.google.com/store/apps/details?id=com.emmalion.liontaxi'>
            download LionTaxi on Google Play Store
          </a>
        </p>
        <h2>Download LionTaxi on Apple App Store</h2>
        <p>
          If you're using an iOS device (e.g iPhone, iPad, etc), you{' '}
          <a href='https://apps.apple.com/app/liontaxi/id1607504124'>
            download LionTaxi on Apple App Store
          </a>
        </p>
        <h2>Download The LionTaxi Drivers App</h2>
        <p>
          The drivers app only supports Android devices now. Support for iOS
          devices will be released soon. For now you can{' '}
          <a href='https://play.google.com/store/apps/details?id=com.emmalion.liontaxidrivers'>
            download the LionTaxi Drivers App on Google Play Store
          </a>
        </p>
      </main>
      <Footer />
    </div>
  );
};
